import styled from 'styled-components';

export const TitleWrapper = styled.div`
  line-height: 32px;
`;

export const ContentForm = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  margin-bottom: 50px;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;
